import { Command } from "./Command";
import _ from "lodash";


export class PropertyChangeCommand extends Command {
    constructor(component, key, newValue) {
        super();
        this._component = component
        this._firebaseKey = key
        this._newValue =  newValue
        this._lodashKey = key.split("/").join(".")
        this._oldValue = _.clone(_.get(this.fbNode, this._lodashKey, ""))
    }

    get hasChanges () {
        return _.isEqual(this._newValue, this._oldValue) === false;
    }

    get fbNode() {
        return this._component.fbNode
    }

    get firebaseRef() {
        return this._component.firebaseRef()
    }

    async execute() {
        this.firebaseRef.setChild(this._firebaseKey, this._newValue).then(()=> {
            _.set(this.fbNode, this._lodashKey, this._newValue)
            this._component.$mount()
        })
    }

    async unExecute() {
        this.firebaseRef.setChild(this._firebaseKey, this._oldValue).then(()=> {
            _.set(this.fbNode, this._lodashKey, this._oldValue)
            this._component.$mount()
        })
    }

    scrollToComponent () {
        return new Promise((resolve) => {
            this._component.$el.scrollIntoView({
                behavior: 'smooth',
                block: "center",
                inline: "nearest"
            })
            setTimeout(resolve,100)
        })
    }
}

export class SizePropertyChangeCommand extends PropertyChangeCommand {
    constructor(component, key, newValue) {
        super(component, key, newValue);
        if (['GridItemWrapper', 'GridItemWrapperV3'].includes(component.name) === false){
            throw 'Component name is not supported for this action'
        }
        this._gridComponent = component.parent()
        this._newValue = Object.assign({}, this._oldValue, newValue)
        this._compareOldValue = {
            dataWidth: this._oldValue.dataWidth,
            dataHeight: this._oldValue.dataHeight,
            dataY: this._oldValue.dataY,
            dataX: this._oldValue.dataX,
        }
        this._compareNewValue = {
            dataWidth: this._newValue.dataWidth,
            dataHeight: this._newValue.dataHeight,
            dataY: this._newValue.dataY,
            dataX: this._newValue.dataX,
        }
    }

    updateElementSize(value){
        this._gridComponent.getGrid().update(
            this._component.$el, {
                w: value.dataWidth,
                h: value.dataHeight,
                x: value.dataX,
                y: value.dataY,
            }
        )
    }

    get hasChanges () {
        return _.isEqual(this._compareNewValue, this._compareOldValue) === false;
    }

    async execute() {
        this.firebaseRef.setChild(this._firebaseKey, this._newValue).then(()=> {
            _.set(this.fbNode, this._lodashKey, this._newValue)
            this.updateElementSize(this._newValue)
        })
    }

    async unExecute() {
        this.firebaseRef.setChild(this._firebaseKey, this._oldValue).then(()=> {
            _.set(this.fbNode, this._lodashKey, this._oldValue)
            this.updateElementSize(this._oldValue)
        })
    }
}
